import * as XLSX from "xlsx";
import { COSTAR_COLUMN_MAP } from "../constants/costarColumns";

export function cleanCoStarValue(field, value) {
  if (value === null || value === undefined || value === '') return null;
  const intFields = ['rba', 'loading_docks', 'drive_ins', 'year_built', 'year_renovated', 'classification'];
  const floatFields = ['land_area', 'for_sale_price', 'last_sale_price', 'percent_leased'];
  if (intFields.includes(field)) {
    const num = parseInt(String(value).replace(/,/g, ''), 10);
    return isNaN(num) ? null : num;
  }
  if (floatFields.includes(field)) {
    const num = parseFloat(String(value).replace(/[,$]/g, ''));
    return isNaN(num) ? null : num;
  }
  if (field === 'last_sale_date') {
    return value ? String(value).slice(0, 10) : null;
  }
  return String(value).trim() || null;
}

export function parseCoStarExcel(workbook) {
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  const rawData = XLSX.utils.sheet_to_json(sheet, { defval: null });

  return rawData.map(row => {
    const prop = {};
    for (const [rawKey, value] of Object.entries(row)) {
      const normalizedKey = rawKey.trim().toLowerCase();
      const dbField = COSTAR_COLUMN_MAP[normalizedKey];
      if (dbField) {
        prop[dbField] = cleanCoStarValue(dbField, value);
      }
    }
    return prop;
  }).filter(p => p.address);
}
